import { Component } from '@wix/thunderbolt-becky-types'
import { FeatureRefs } from '../cssFeatures.types'
import { createCssCompNode } from '../cssCompNode'
import { CompData } from '@wix/thunderbolt-becky-root'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { MeshChild, MeshChildCompNode } from './mesh.types'
import { shouldRemoveChildFromStructure, shouldCalculateMeshForComp, shouldCalculateMesh1 } from './meshCompNodeHelpers'

export const meshChild = (isEditor: boolean) =>
	createCssCompNode('mesh', 'meshChild', {
		getDependencies: (component: Component, refs: FeatureRefs<'mesh'>) => {
			if (shouldRemoveChildFromStructure(component)) {
				return null
			}
			const deps =
				component.componentType === 'Column'
					? {
							compData: ({
								props: refs.propertyQuery(component.propertyQuery!),
								style: refs.styleId(component.styleId!),
								data: refs.dataQuery(component.dataQuery!),
							} as unknown) as CompData,
					  }
					: {}
			return {
				...deps,
				autoHeightWrapper: isEditor ? refs.autoHeightWrapper?.(component) : false,
				meshChildren: (component.components || []).map(refs.meshChild),
				isMobileView: envRefs.isMobileView,
				compSingleLayout: refs.compSingleLayout(component),
				hasResponsiveLayout: refs.hasResponsiveLayout(component),
				isOneDocMigrated: envRefs.isOneDocMigrated,
				classicRotation: refs.classicRotation(component),
			}
		},
		toViewItem: (component, deps) => {
			if (!deps || deps.hasResponsiveLayout) {
				return null
			}

			// Remove hidden & ghost children components
			const meshChildren = deps.meshChildren.filter((child: MeshChildCompNode) => !!child) as Array<MeshChild>
			const componentWithMeshChildrenOnly = {
				...component,
				components: meshChildren.map((child: MeshChild) => child.id),
			}

			const {
				isMobileView,
				autoHeightWrapper,
				compData,
				compSingleLayout,
				hasResponsiveLayout,
				classicRotation,
			} = deps

			const shouldCalculateMesh = deps.isOneDocMigrated
				? shouldCalculateMeshForComp(component, compSingleLayout)
				: shouldCalculateMesh1(component, hasResponsiveLayout)

			return {
				id: component.id,
				component: componentWithMeshChildrenOnly,
				meshChildren,
				isMobileView,
				autoHeightWrapper, // mesh1 only
				compData,
				shouldCalculateMesh,
				compSingleLayout, // mesh3 only
				classicRotation, // mesh3 only
			} as MeshChildCompNode
		},
	})
